import styles from './ImageFrameEditor.module.css';

export default function ImageFrameEditor({ url, fitMode = 'cover', focalY = 50, onChange }) {
  const fit = fitMode || 'cover';
  const y = focalY ?? 50;

  return (
    <div className={styles.editor}>
      <div className={styles.frame}>
        <img
          src={url}
          alt="Preview"
          className={styles.previewImg}
          style={{
            objectFit: fit,
            objectPosition: `center ${y}%`,
          }}
        />
      </div>

      <div className={styles.controls}>
        <div className={styles.toggleGroup}>
          <button
            type="button"
            className={`${styles.toggleBtn} ${fit === 'cover' ? styles.toggleBtnActive : ''}`}
            onClick={() => onChange({ fitMode: 'cover' })}
          >
            Fill (Crop)
          </button>
          <button
            type="button"
            className={`${styles.toggleBtn} ${fit === 'contain' ? styles.toggleBtnActive : ''}`}
            onClick={() => onChange({ fitMode: 'contain' })}
          >
            Fit (Full)
          </button>
        </div>

        {fit === 'cover' && (
          <div className={styles.sliderGroup}>
            <label className={styles.sliderLabel}>
              Vertical position
              <span className={styles.sliderValue}>{y}%</span>
            </label>
            <input
              type="range"
              min="0"
              max="100"
              value={y}
              className={styles.slider}
              onChange={(e) => onChange({ focalY: Number(e.target.value) })}
            />
            <div className={styles.sliderHints}>
              <span>Top</span>
              <span>Bottom</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
